import { css } from 'styled-components';
import { color } from '@whitelabel/helpers/style/colors';

export const linkUnderlineStyles = css`
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: 0.25s ease-in-out;
`;

export const linkUnderlineHoverStyles = css`
  box-shadow: none;
  text-decoration: underline;
  filter: brightness(50%);
`;

const globalTypeStyle = css`
  h1,
  h2,
  h3,
  h6,
  h3.heading-block__title > span,
  h6.heading-block__title > span,
  form label,
  input.form-control,
  .form-group small {
    color: ${color('prussianBlue')};
  }

  .DateInput_input,
  .CalendarDay,
  .CalendarMonth_caption,
  .DayPicker_weekHeader_li {
    color: ${color('prussianBlue')};
  }

  .react-select__control {
    .react-select__single-value,
    .react-select__placeholder {
      color: ${color('prussianBlue')};
    }
    .react-select__value-container {
      .react-select__single-value,
      .react-select__placeholder {
        color: ${color('prussianBlue')};
      }
    }
  }

  .modal-body p,
  .modal-body label.form-label {
    color: ${color('prussianBlue')};
  }
`;

export default globalTypeStyle;
